export class IrwinAttributes {
  constructor(irwinAttributes: IrwinAttributes) {
    this.ABCDMisc = irwinAttributes.ABCDMisc;
    this.AdditionalFuelModel = irwinAttributes.AdditionalFuelModel;
    this.ADSPermissionState = irwinAttributes.ADSPermissionState;
    this.CalculatedAcres = irwinAttributes.CalculatedAcres;
    this.ContainmentDateTime = irwinAttributes.ContainmentDateTime;
    this.ControlDateTime = irwinAttributes.ControlDateTime;
    this.CreatedBySystem = irwinAttributes.CreatedBySystem;
    this.CreatedOnDateTime = irwinAttributes.CreatedOnDateTime;
    this.CriticalResourceNeeds = irwinAttributes.CriticalResourceNeeds;
    this.DailyAcres = irwinAttributes.DailyAcres;
    this.DiscoveryAcres = irwinAttributes.DiscoveryAcres;
    this.DispatchCenterID = irwinAttributes.DispatchCenterID;
    this.EstimatedContainmentDate = irwinAttributes.EstimatedContainmentDate;
    this.EstimatedCostToDate = irwinAttributes.EstimatedCostToDate;
    this.Fatalities = irwinAttributes.Fatalities;
    this.FinalAcres = irwinAttributes.FinalAcres;
    this.FinalFireReportApprovedBy = irwinAttributes.FinalFireReportApprovedBy;
    this.FinalFireReportApprovedByTitle = irwinAttributes.FinalFireReportApprovedByTitle;
    this.FinalFireReportApprovedByUnit = irwinAttributes.FinalFireReportApprovedByUnit;
    this.FinalFireReportApprovedDate = irwinAttributes.FinalFireReportApprovedDate;
    this.FinalFireReportNarrative = irwinAttributes.FinalFireReportNarrative;
    this.FinalStrategyAttainedDateTime = irwinAttributes.FinalStrategyAttainedDateTime;
    this.FireBehaviorDescription = irwinAttributes.FireBehaviorDescription;
    this.FireBehaviorGeneral = irwinAttributes.FireBehaviorGeneral;
    this.FireBehaviorGeneral1 = irwinAttributes.FireBehaviorGeneral1;
    this.FireBehaviorGeneral2 = irwinAttributes.FireBehaviorGeneral2;
    this.FireBehaviorGeneral3 = irwinAttributes.FireBehaviorGeneral3;
    this.FireCause = irwinAttributes.FireCause;
    this.FireCauseGeneral = irwinAttributes.FireCauseGeneral;
    this.FireCauseSpecific = irwinAttributes.FireCauseSpecific;
    this.FireCode = irwinAttributes.FireCode;
    this.FireDepartmentID = irwinAttributes.FireDepartmentID;
    this.FireDiscoveryDateTime = irwinAttributes.FireDiscoveryDateTime;
    this.FireGrowthCessationDateTime = irwinAttributes.FireGrowthCessationDateTime;
    this.FireIgnitionDateTime = irwinAttributes.FireIgnitionDateTime;
    this.FireMgmtComplexity = irwinAttributes.FireMgmtComplexity;
    this.FireOutDateTime = irwinAttributes.FireOutDateTime;
    this.FireStrategyDirExtPercent = irwinAttributes.FireStrategyDirExtPercent;
    this.FireStrategyIndirConfPercent = irwinAttributes.FireStrategyIndirConfPercent;
    this.FireStrategyConfinePercent = irwinAttributes.FireStrategyConfinePercent;
    this.FireStrategyFullSuppPercent = irwinAttributes.FireStrategyFullSuppPercent;
    this.FireStrategyMonitorPercent = irwinAttributes.FireStrategyMonitorPercent;
    this.FireStrategyPointZonePercent = irwinAttributes.FireStrategyPointZonePercent;
    this.FiscallyResponsibleUnit = irwinAttributes.FiscallyResponsibleUnit;
    this.FSJobCode = irwinAttributes.FSJobCode;
    this.GACC = irwinAttributes.GACC;
    this.FSOverrideCode = irwinAttributes.FSOverrideCode;
    this.HasFatalities = irwinAttributes.HasFatalities;
    this.HasInjuries = irwinAttributes.HasInjuries;
    this.ICS209Remarks = irwinAttributes.ICS209Remarks;
    this.ICS209ReportDateTime = irwinAttributes.ICS209ReportDateTime;
    this.ICS209ReportForTimePeriodFrom = irwinAttributes.ICS209ReportForTimePeriodFrom;
    this.ICS209ReportForTimePeriodTo = irwinAttributes.ICS209ReportForTimePeriodTo;
    this.ICS209ReportStatus = irwinAttributes.ICS209ReportStatus;
    this.IncidentCommanderName = irwinAttributes.IncidentCommanderName;
    this.IncidentComplexityLevel = irwinAttributes.IncidentComplexityLevel;
    this.IncidentManagementOrganization = irwinAttributes.IncidentManagementOrganization;
    this.IncidentName = irwinAttributes.IncidentName;
    this.IncidentShortDescription = irwinAttributes.IncidentShortDescription;
    this.IncidentSize = irwinAttributes.IncidentSize;
    this.IncidentTypeCategory = irwinAttributes.IncidentTypeCategory;
    this.IncidentTypeKind = irwinAttributes.IncidentTypeKind;
    this.INFORMUserName = irwinAttributes.INFORMUserName;
    this.InFuelTreatment = irwinAttributes.InFuelTreatment;
    this.InitialFireStrategy = irwinAttributes.InitialFireStrategy;
    this.InitialLatitude = irwinAttributes.InitialLatitude;
    this.InitialLongitude = irwinAttributes.InitialLongitude;
    this.InitialResponseAcres = irwinAttributes.InitialResponseAcres;
    this.InitialResponseDateTime = irwinAttributes.InitialResponseDateTime;
    this.Injuries = irwinAttributes.Injuries;
    this.InNFPORS = irwinAttributes.InNFPORS;
    this.IrwinID = irwinAttributes.IrwinID;
    this.IsFireCauseInvestigated = irwinAttributes.IsFireCauseInvestigated;
    this.IsFireCodeRequested = irwinAttributes.IsFireCodeRequested;
    this.IsFSAssisted = irwinAttributes.IsFSAssisted;
    this.IsInitialFireStrategyMet = irwinAttributes.IsInitialFireStrategyMet;
    this.IsMultiJurisdictional = irwinAttributes.IsMultiJurisdictional;
    this.IsQuarantined = irwinAttributes.IsQuarantined;
    this.IsReimbursable = irwinAttributes.IsReimbursable;
    this.IsTrespass = irwinAttributes.IsTrespass;
    this.IsUnifiedCommand = irwinAttributes.IsUnifiedCommand;
    this.IsValid = irwinAttributes.IsValid;
    this.LocalIncidentIdentifier = irwinAttributes.LocalIncidentIdentifier;
    this.ModifiedBySystem = irwinAttributes.ModifiedBySystem;
    this.ModifiedOnDateTime = irwinAttributes.ModifiedOnDateTime;
    this.OBJECTID = irwinAttributes.OBJECTID;
    this.OtherStructuresDestroyed = irwinAttributes.OtherStructuresDestroyed;
    this.OtherStructuresThreatened = irwinAttributes.OtherStructuresThreatened;
    this.PercentContained = irwinAttributes.PercentContained;
    this.PercentPerimeterToBeContained = irwinAttributes.PercentPerimeterToBeContained;
    this.PlannedActions = irwinAttributes.PlannedActions;
    this.POOCity = irwinAttributes.POOCity;
    this.POOCounty = irwinAttributes.POOCounty;
    this.POODispatchCenterID = irwinAttributes.POODispatchCenterID;
    this.POOFips = irwinAttributes.POOFips;
    this.POOJurisdictionalAgency = irwinAttributes.POOJurisdictionalAgency;
    this.POOJurisdictionalUnit = irwinAttributes.POOJurisdictionalUnit;
    this.POOJurisdictionalUnitParentUnit = irwinAttributes.POOJurisdictionalUnitParentUnit;
    this.POOLandownerCategory = irwinAttributes.POOLandownerCategory;
    this.POOLandownerKind = irwinAttributes.POOLandownerKind;
    this.POOLegalDescPrincipalMeridian = irwinAttributes.POOLegalDescPrincipalMeridian;
    this.POOLegalDescQtr = irwinAttributes.POOLegalDescQtr;
    this.POOLegalDescQtrQtr = irwinAttributes.POOLegalDescQtrQtr;
    this.POOLegalDescRange = irwinAttributes.POOLegalDescRange;
    this.POOLegalDescSection = irwinAttributes.POOLegalDescSection;
    this.POOLegalDescTownship = irwinAttributes.POOLegalDescTownship;
    this.POOPredictiveServiceAreaID = irwinAttributes.POOPredictiveServiceAreaID;
    this.POOProtectingAgency = irwinAttributes.POOProtectingAgency;
    this.POOProtectingUnit = irwinAttributes.POOProtectingUnit;
    this.POOState = irwinAttributes.POOState;
    this.PredominantFuelGroup = irwinAttributes.PredominantFuelGroup;
    this.PredominantFuelModel = irwinAttributes.PredominantFuelModel;
    this.PrimaryFuelModel = irwinAttributes.PrimaryFuelModel;
    this.ProjectedIncidentActivity12 = irwinAttributes.ProjectedIncidentActivity12;
    this.ProjectedIncidentActivity24 = irwinAttributes.ProjectedIncidentActivity24;
    this.ProjectedIncidentActivity48 = irwinAttributes.ProjectedIncidentActivity48;
    this.ProjectedIncidentActivity72 = irwinAttributes.ProjectedIncidentActivity72;
    this.ProjectedIncidentActivity72Plus = irwinAttributes.ProjectedIncidentActivity72Plus;
    this.ResidencesDestroyed = irwinAttributes.ResidencesDestroyed;
    this.ResidencesThreatened = irwinAttributes.ResidencesThreatened;
    this.SecondaryFuelModel = irwinAttributes.SecondaryFuelModel;
    this.SignificantEvents = irwinAttributes.SignificantEvents;
    this.SummaryFuelModel = irwinAttributes.SummaryFuelModel;
    this.TotalIncidentPersonnel = irwinAttributes.TotalIncidentPersonnel;
    this.UniqueFireIdentifier = irwinAttributes.UniqueFireIdentifier;
    this.WeatherConcerns = irwinAttributes.WeatherConcerns;
    this.WFDSSDecisionStatus = irwinAttributes.WFDSSDecisionStatus;
    this.GlobalID = irwinAttributes.GlobalID;
    this.IsDispatchComplete = irwinAttributes.IsDispatchComplete;
    this.EstimatedFinalCost = irwinAttributes.EstimatedFinalCost;
    this.OrganizationalAssessment = irwinAttributes.OrganizationalAssessment;
    this.RelativeRiskRating = irwinAttributes.RelativeRiskRating;
    this.WFDSSStrategySliderValue = irwinAttributes.WFDSSStrategySliderValue;
    this.StrategicDecisionPublishDate = irwinAttributes.StrategicDecisionPublishDate;
    this.ArchivedOn = irwinAttributes.ArchivedOn;
  }



  ABCDMisc?: any;
  AdditionalFuelModel?: any;
  ADSPermissionState: string;
  CalculatedAcres?: any;
  ContainmentDateTime?: any;
  ControlDateTime?: any;
  CreatedBySystem: string;
  CreatedOnDateTime: number;
  CriticalResourceNeeds?: any;
  DailyAcres: number;
  DiscoveryAcres: number;
  DispatchCenterID: string;
  EstimatedContainmentDate?: any;
  EstimatedCostToDate?: any;
  Fatalities?: any;
  FinalAcres?: any;
  FinalFireReportApprovedBy?: any;
  FinalFireReportApprovedByTitle?: any;
  FinalFireReportApprovedByUnit?: any;
  FinalFireReportApprovedDate?: any;
  FinalFireReportNarrative?: any;
  FinalStrategyAttainedDateTime?: any;
  FireBehaviorDescription?: any;
  FireBehaviorGeneral?: any;
  FireBehaviorGeneral1?: any;
  FireBehaviorGeneral2?: any;
  FireBehaviorGeneral3?: any;
  FireCause: string;
  FireCauseGeneral?: any;
  FireCauseSpecific?: any;
  FireCode?: any;
  FireDepartmentID?: any;
  FireDiscoveryDateTime: number;
  FireGrowthCessationDateTime?: any;
  FireIgnitionDateTime?: any;
  FireMgmtComplexity?: any;
  FireOutDateTime?: any;
  FireStrategyDirExtPercent?: any;
  FireStrategyIndirConfPercent?: any;
  FireStrategyConfinePercent?: any;
  FireStrategyFullSuppPercent?: any;
  FireStrategyMonitorPercent?: any;
  FireStrategyPointZonePercent?: any;
  FiscallyResponsibleUnit?: any;
  FSJobCode?: any;
  FSOverrideCode?: any;
  GACC: string;
  HasFatalities?: any;
  HasInjuries?: any;
  ICS209Remarks?: any;
  ICS209ReportDateTime?: any;
  ICS209ReportForTimePeriodFrom?: any;
  ICS209ReportForTimePeriodTo?: any;
  ICS209ReportStatus?: any;
  IncidentCommanderName?: any;
  IncidentComplexityLevel: string;
  IncidentManagementOrganization?: any;
  IncidentName: string;
  IncidentShortDescription?: any;
  IncidentSize?:number;
  IncidentTypeCategory: string;
  IncidentTypeKind: string;
  INFORMUserName?: any;
  InFuelTreatment?: any;
  InitialFireStrategy?: any;
  InitialLatitude: number;
  InitialLongitude: number;
  InitialResponseAcres?: any;
  InitialResponseDateTime?: any;
  Injuries?: any;
  InNFPORS?: any;
  IrwinID: string;
  IsFireCauseInvestigated?: any;
  IsFireCodeRequested: number;
  IsFSAssisted?: any;
  IsInitialFireStrategyMet?: any;
  IsMultiJurisdictional?: any;
  IsQuarantined: number;
  IsReimbursable?: any;
  IsTrespass?: any;
  IsUnifiedCommand?: any;
  IsValid: number;
  LocalIncidentIdentifier: string;
  ModifiedBySystem: string;
  ModifiedOnDateTime: number;
  OBJECTID: number;
  OtherStructuresDestroyed?: any;
  OtherStructuresThreatened?: any;
  PercentContained?: any;
  PercentPerimeterToBeContained?: any;
  PlannedActions?: any;
  POOCity?: any;
  POOCounty: string;
  POODispatchCenterID: string;
  POOFips: string;
  POOJurisdictionalAgency: string;
  POOJurisdictionalUnit: string;
  POOJurisdictionalUnitParentUnit?: any;
  POOLandownerCategory?: any;
  POOLandownerKind?: any;
  POOLegalDescPrincipalMeridian?: any;
  POOLegalDescQtr?: any;
  POOLegalDescQtrQtr?: any;
  POOLegalDescRange?: any;
  POOLegalDescSection?: any;
  POOLegalDescTownship?: any;
  POOPredictiveServiceAreaID: string;
  POOProtectingAgency: string;
  POOProtectingUnit: string;
  POOState: string;
  PredominantFuelGroup?: any;
  PredominantFuelModel?: any;
  PrimaryFuelModel?: any;
  ProjectedIncidentActivity12?: any;
  ProjectedIncidentActivity24?: any;
  ProjectedIncidentActivity48?: any;
  ProjectedIncidentActivity72?: any;
  ProjectedIncidentActivity72Plus?: any;
  ResidencesDestroyed?: any;
  ResidencesThreatened?: any;
  SecondaryFuelModel?: any;
  SignificantEvents?: any;
  SummaryFuelModel?: any;
  TotalIncidentPersonnel?: any;
  UniqueFireIdentifier: string;
  WeatherConcerns?: any;
  WFDSSDecisionStatus: string;
  GlobalID: string;
  IsDispatchComplete?: any;
  EstimatedFinalCost?: any;
  OrganizationalAssessment?: any;
  RelativeRiskRating?: any;
  WFDSSStrategySliderValue?: any;
  StrategicDecisionPublishDate?: any;
  ArchivedOn?: any;
}

export class NewIrwinIncidentForCreate {
  DiscoveryAcres: string;
  FireCause: string;
  FireDiscoveryDateTime: string;
  IncidentName: string;
  InitialLatitude: string;
  InitialLongitude: string;
  LocalIncidentIdentifier: string;
  POOProtectingUnit: string;
}
